export default "__VITE_ASSET__mJxj8TfW__"